import React from "react";
import {useConsentStore} from "../store/consent-store";
import Cookies from "js-cookie";
import Portal from "./ui/portal";

const Consent = () => {
  const [isVisible, setVisible] = React.useState(true);
  const [isFullConsentVisible, setFullConsentVisible] = React.useState(false);

  const updateConsent = useConsentStore((state) => state.updateConsent);
  const consent = useConsentStore((state) => state.consent);

  const cookieConsent = Cookies.get("consent");

  const handleConfirmConsent = () => {
    Cookies.set("consent", "true");
    setVisible(false);
    setFullConsentVisible(false);
    updateConsent(true);
  };

  const handleClose = () => {
    setVisible(false);
    setFullConsentVisible(false)
  }

  React.useEffect(() => {
    if (cookieConsent === "true" || consent) {
      setVisible(false);
      updateConsent(true);
    }
  }, [Cookies, handleConfirmConsent]);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      if (!consent) {
        setFullConsentVisible(true);
        setVisible(false)
      }
    }, 20000); // 20 сек

    return () => clearTimeout(timer); // Очистка при размонтировании
  }, []);

  return (
      <>
        {isVisible && <div className="consent">
          <p>
            Продолжая пользоваться сайтом, вы соглашаетесь на использование cookie и
            обработку данных согласно{" "}
            <a
                className="consent-link"
                href="/agreement.docx"
                target="_blank"
            >
              Политикe конфиденциальности
            </a>
            .
          </p>
          <div className='consent-btn-box'>
            <button className="consent-button" onClick={handleConfirmConsent}>
              Хорошо
            </button>
            <button className="consent-btn-close" onClick={handleClose}>
              Закрыть
            </button>
          </div>
        </div>}

        {(isFullConsentVisible && !consent) && <Portal>
          <div
              className='fixed top-0 right-0 bottom-0 left-0 bg-black/50 z-50 flex items-center justify-center w-full '>
            <div className="max-w-[345px] w-full bg-white p-5 rounded-md shadow-2xl">
              <p>
                Продолжая пользоваться сайтом, вы соглашаетесь на использование cookie и
                обработку данных согласно{" "}
                <a
                    className=""
                    href="/agreement.docx"
                    target="_blank"
                >
                  Политикe конфиденциальности
                </a>
                .
              </p>
              <div className='mt-3 flex items-center gap-2'>
                <button className="bg-[#418A9F] text-white px-6 py-2 rounded font-medium"
                        onClick={handleConfirmConsent}>
                  Хорошо
                </button>
                <button className="px-3 py-2 rounded" onClick={handleClose}>
                  Отказаться
                </button>
              </div>
            </div>
          </div>
        </Portal>}
      </>
  );
};

export default Consent;